// extracted by mini-css-extract-plugin
export default {"StepIndicator":"StepIndicator_StepIndicator__RJcAq"};